<template>
  <div id="content" class="content" style="margin-left:0px;">
    <h1 class="page-header" style="text-align:left">
      出库管理
      <small>/提交出库</small>
    </h1>
    <div
      id="page-container"
      class="in page-sidebar-fixed page-header-fixed"
      style="padding-top:0px;"
    >
      <!-- begin #content -->
      <div
        id="content"
        class="content"
        style="margin-left:0px;padding-top: 0px;padding-left:0px;padding-right:0px;"
      >
        <!-- begin breadcrumb -->
        <div class="row">
          <!-- begin col-10 -->
          <div class="col-lg-12">
            <!-- begin panel -->
            <div class="panel panel-inverse">
              <!-- begin panel-heading -->
              <div class="panel-heading">
                <div class="panel-heading-btn">
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-default"
                    data-click="panel-expand"
                  >
                    <i class="fa fa-expand"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-success"
                    data-click="panel-reload"
                  >
                    <i class="fa fa-redo"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-warning"
                    data-click="panel-collapse"
                  >
                    <i class="fa fa-minus"></i>
                  </a>
                  <a
                    href="javascript:;"
                    class="btn btn-xs btn-icon btn-circle btn-danger"
                    data-click="panel-remove"
                  >
                    <i class="fa fa-times"></i>
                  </a>
                </div>
                <h4 class="panel-title panelTitle">提交出库</h4>
              </div>
              <!-- end panel-heading -->
              <el-card class="box-card">
                <div>
                  <div class="top-hd">
                    <el-row>
                      <el-form ref="form" :model="form" label-width="130px" style="width: 70%;">
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light" style="margin-left:30px;">
                            <el-form-item
                              label="出库单号："
                              style="margin-left:5px; margin-right:30px;"
                              class="btn1"
                            >
                              <el-input v-model="form.orderNo" placeholder></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="12">
                          <div class="grid-content bg-purple-light" style="margin-left:10%;">
                            <el-form-item label="出库单号总数量：" class="btn1">
                              <el-input v-model="form.orderCount" placeholder></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                        <el-col :span="24" style="margin-top:5%;">
                          <div class="grid-content bg-purple-light" style="margin-left:5%;">
                            <el-form-item label="备注：" prop="note">
                              <el-input
                                type="textarea"
                                v-model="form.note"
                                maxlength="100"
                                style=" width:102%;"
                              ></el-input>
                            </el-form-item>
                          </div>
                        </el-col>
                      </el-form>
                    </el-row>
                  </div>

                  <!-- 03 -->
                  <div style="width:100%;margin-top:80px;margin-left:15%">
                    <el-table
                      :data="tableData3"
                      style="width: 70%"
                      size="medium"
                      border
                      :header-cell-style="{background:'#ffffff',color:'#606266'}"
                    >
                      <el-table-column
                        width="105"
                        prop="goodsid"
                        label="序号"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="500"
                        prop="goodsName"
                        label="商品名称"
                        align="center"
                        resizable
                      ></el-table-column>
                      <el-table-column
                        width="500"
                        prop="recomName"
                        label="下单数量数量"
                        align="center"
                        resizable
                      ></el-table-column>
                    </el-table>
                  </div>
                  <!-- 04 -->
                  <div class="bottom">
                    <div class="block">
                      <!---- totalCount  ------- pageSize   ----->
                      <el-pagination
                        :current-page="pageNo"
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :page-sizes="[10, 20, 50]"
                        :page-size="pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="totalCount"
                        background
                      ></el-pagination>
                    </div>
                  </div>
                  <div class="divsub">
                    <button class="btn btn-primary btn-sm ButtonColor btn_sub" @click="submit()">提交</button>
                    <button
                      class="btn btn-primary btn-sm ButtonColor btn_sub_back"
                      @click="goback()"
                    >返回</button>
                  </div>
                </div>
              </el-card>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Qs from "qs";
import axios from "axios";
import http from "../../common/http";
import MethodsBus from "../../common/methodBus";
import eventBus from "../../common/eventBus";
import { error } from "util";
export default {
  name: "outbounddetail",
  data() {
    return {
      pageNo: 1,
      pageSize: 10,
      totalCount: 1,
      form: {
        //合同编号
        orderNo: "",
        // 合同标题
        orderCount: "",
        recomName: "",
        note: ""
      },
      ruleForm: {
        contractNo: ""
      },
      //   表格的 数据
      tableData3: [],
      outId: "",

      rules: {
        note: [
          { required: true, message: "请输入合同编号", trigger: "blur" },
          { trigger: "blur" }
        ]
      }
    };
  },
  created() {},
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      this.tableData3 = JSON.parse(
        localStorage.getItem("userInput")
      ).b2cTobOutDetails;
      this.form.orderNo = JSON.parse(this.$route.query.data).orderNo;
      this.form.orderCount = JSON.parse(this.$route.query.data).orderCount;
    },
    // 提交
    submit() {
      let that = this;
      const options = {
        url: "/distribution/B2cTobOutController/addNote",
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        // 请求参数
        data: Qs.stringify({
          outId: JSON.parse(this.$route.query.data).outId,
          note: that.form.note
        })
      };
      axios(options)
        .then(function(response) {
          if (response.data.code == 200) {
            localStorage.removeItem("userInput");
            that.$router.push({ path: "/outbound" });
            that.$notify({
              title: "成功",
              message: response.data.message,
              type: "success"
            });
          } else {
            that.$notify.error({
              title: "错误",
              message: "请填写备注信息"
            });
          }
        })
        .catch(error => {
          http.handleHttpError(error, this);
        });
    },
    goback() {
      this.$router.push({
        name: "product",
        path: "/product"
      });
      localStorage.removeItem("userInput");
    },
    // 上传凭证的处理函数
    handleClick(row, index) {
      this.outerVisible = true;
      this.EditDialog = 3;
      this.DialogTitle = "详情";
      this.CurrentSelection = row;
    },
    // 删除的 处理函数
    del(item) {
      //console.log(row);
      this.outerVisible = true;
      this.EditDialog = 2;
      this.CurrentSelection = item;
    },
    // 编辑函数
    edit(row) {
      // console.log(item);
      this.outerVisible = true;
      this.DialogTitle = "编辑";
      this.EditDialog = 1;
      if (this.$refs["ruleForm"]) {
        this.$refs["ruleForm"].resetFields();
      }
      this.ruleForm = MethodsBus.cloneRow(row);
    },

    // 对话框的 【确定 】 处理函数
    MakeSure() {
      let that = this;
      that.disabled = true;
      axios
        .post(
          "distribution/B2cGoodsBrandController/deleteBrand?brandId=" +
            this.CurrentSelection.brandId
        )
        .then(function(response) {
          that.outerVisible = false;
          that.disabled = false;
          if (response.data.code == 200) {
            that.initdata();
            that.$notify({
              title: "成功",
              message: "删除成功",
              type: "success"
            });
          } else {
            http.handleEorrorCode(response, that);
          }
        })
        .catch(function(error) {
          that.disabled = false;
          http.handleHttpError(error, that);
        });
    },
    //   startTime  开始时间
    getstarttime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var date = now.getDate(); //得到日期
      //   var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒

      if (now.getMonth() + 1) {
        if (month < 10) month = "0" + (now.getMonth() + 1);
        date = "0" + "1";
        hour = "0" + "0";
        minu = "0" + "0";
        sec = "0" + "0";
      }
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    // endtime;结束时间
    getEndtime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      var day = now.getDay(); //得到周几
      var hour = now.getHours(); //得到小时
      var minu = now.getMinutes(); //得到分钟
      var sec = now.getSeconds(); //得到秒
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      if (hour < 10) hour = "0" + hour;
      if (minu < 10) minu = "0" + minu;
      if (sec < 10) sec = "0" + sec;
      var time = "";
      time =
        year + "-" + month + "-" + date + " " + hour + ":" + minu + ":" + sec;
      return time;
    },
    //  时间的处理函数
    ChangePicker() {
      if (this.Formdata.TimeValue !== null) {
        this.startTime = this.FormatAllDate(this.Formdata.TimeValue[0]);
        this.endTime = this.FormatAllDate(this.Formdata.TimeValue[1]);
      } else if (this.Formdata.TimeValue === null) {
        this.startTime = "";
        this.endTime = "";
      }
    },
    FormatAllDate(sDate) {
      var date = new Date(sDate);
      var seperator1 = "-";
      var seperator2 = ":";
      var month = date.getMonth() + 1;
      var strDate = date.getDate();
      var hours = date.getHours();
      var minutes = date.getMinutes();
      var seconds = date.getSeconds();
      //月
      if (month >= 1 && month <= 9) {
        month = "0" + month;
      }
      //日
      if (strDate >= 0 && strDate <= 9) {
        strDate = "0" + strDate;
      }
      //时
      if (hours >= 0 && hours <= 9) {
        hours = "0" + hours;
      }
      //分
      if (minutes >= 0 && minutes <= 9) {
        minutes = "0" + minutes;
      }
      //秒
      if (seconds >= 0 && seconds <= 9) {
        seconds = "0" + seconds;
      }
      //格式化后日期为：yyyy-MM-dd HH:mm:ss
      var currentdate =
        date.getFullYear() +
        seperator1 +
        month +
        seperator1 +
        strDate +
        " " +
        hours +
        seperator2 +
        minutes +
        seperator2 +
        seconds;

      return currentdate;
    },
    // 分页处理函数 分页-- 获取 每页  value条
    handleSizeChange(value) {
      this.pageSize = value;
      // console.log(this.pageSize);
      this.pageNo = 1;
      this.initData();
    },
    //  获取 当前  value
    handleCurrentChange(value) {
      this.pageNo = value;
      console.log(this.pageNo);
      this.initData();
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.clear {
  clear: both;
}
.PaginationStyle {
  float: right;
  margin-top: 8px;
}
.left {
  margin-left: 20px;
}
.upload {
  margin-top: 20px;
  margin-left: 13%;
  display: flex;
  justify-content: flex-start;
}
.upload_left {
  /* margin-top: 50px; */
  padding-right: 30px;
  letter-spacing: 1px;
}
.el-textarea {
  top: 0px;
  left: -12px;
}
/*  */
.panelTitle {
  padding-left: 15px;
  text-align: left;
}
.ButtonColor {
  color: #fff !important;
}
.divsub {
  margin-top: 2%;
  margin-bottom: 2%;
}

.LineSpacing {
  margin-top: 16px;
}
.InputWidth {
  width: 202px;
}
.top-hd {
  margin-top: 20px;
  margin: 0 auto;
  margin-left: 15%;
}
.text {
  font-size: 14px;
}

.item {
  margin-bottom: 18px;
}

.clearfix:before,
.clearfix:after {
  display: table;
  content: "";
}
.clearfix:after {
  clear: both;
}

.box-card {
  width: 100%;
}

.bottom {
  display: flex;
  justify-content: flex-end;
  margin-top: 30px;
}
.bottom_table {
  display: flex;
  justify-content: flex-start;
}

.grid-content {
  border-radius: 4px;
  min-height: 20px;
}
.top-thone {
  margin-left: 20px;
  margin-top: 20px;
}
.btn1 {
  background-color: #fff;
}

.bot-btn {
  float: left;
  margin-left: 80%;
  margin-top: 1%;
  margin-bottom: 2%;
}
.bot-btn-left {
  margin-left: 70px;
}
.top-bot {
  float: left;
}
</style>



// WEBPACK FOOTER //
// src/components/ContractManagement/outboundsubmit.vue